export { default as HotelCreate } from './create';
export { default as HotelList } from './list';
export { default as HotelView } from './view';
